import React, { useState, useEffect, useCallback } from 'react';
import { GenericStep } from '@/components/FullWidthTemplate/GenericStep';
import * as Styles from './FtpMigrationForm.styles';
import { TextField } from 'gatorcomponents';
import { defaultFormData } from './FtpMigrationForm.enum';

const FtpMigrationForm = ({
  locales, buttonsProps, onSubmit, loading, showToast, status,
}) => {
  const [formData, setFormData] = useState(defaultFormData);
  const [isValid, setIsValid] = useState(false);

  const handleOnSubmit = useCallback(() => {
    const formValues = {
      userName: formData.userName.value,
      password: formData.password.value,
      databaseName: formData.databaseName.value,
      sourcePath: formData.sourcePath.value,
      sourceDomain: formData.sourceDomain.value,
      sourceIp: formData.sourceIp.value,
      destinationPath: formData.destinationPath.value,
      sourcePort: formData.sourcePort.value,
    };

    onSubmit && onSubmit({ formData: formValues });
  }, [formData, onSubmit]);


  const stepProps = useCallback(() => ({
    title: locales.title,
    description: locales.description,
    buttonsProps: {
      ...buttonsProps,
      rightButton: {
        ...buttonsProps.rightButton,
        onClick: handleOnSubmit,
        disabled: !isValid || loading,
        loading,
        testId: 'migration-form-submit',
      },
    },
  }), [buttonsProps, locales, isValid, handleOnSubmit, loading]);

  const validateForm = (formData) => {
    const allRequiredFilled = Object.keys(formData).every((key) => {
      const { value, required } = formData[key];

      if (required && !value) {
        return false;
      }

      return true;
    });
    const isValid = allRequiredFilled;
    setIsValid(isValid);
  };

  const onChangeField = (event) => {
    const { name, value } = event.target;

    const newFormData = { ...formData };
    newFormData[name].value = value;

    validateForm(newFormData);
    setFormData(newFormData);
  };

  const resetForm = useCallback(() => {
    setFormData({
      userName: {
        value: '',
        required: true,
      },
      password: {
        value: '',
        required: true,
      },
      databaseName: {
        value: '',
        required: true,
      },
      sourcePath: {
        value: '',
        required: true,
      },
      sourceIp: {
        value: '',
        required: true,
      },
      sourceDomain: {
        value: '',
        required: true,
      },
      destinationPath: {
        value: '',
        required: false,
      },
      sourcePort: {
        value: '',
        required: false,
      },
    });
    setIsValid(false);
  }, []);

  useEffect(() => {
    if (status === 'failure') {
      showToast({
        title: locales.toast.title,
        info: locales.toast.info,
        type: 'error',
      });
    }
  }, [showToast, status, locales]);

  useEffect(() => {
    resetForm();
  }, [resetForm]);


  return (
    <GenericStep {...stepProps()}>
      <Styles.Wrapper>
        <Styles.Form data-testid="ftp-migration-form">
          <TextField
            label={locales.form.userName}
            name="userName"
            testId="input-userName"
            value={formData.userName.value}
            onChange={onChangeField}
            helpText={locales.required}
          />
          <TextField
            label={locales.form.password}
            name="password"
            type="password"
            testId="input-password"
            value={formData.password.value}
            onChange={onChangeField}
            helpText={locales.required}
          />
          <TextField
            label={locales.form.databaseName}
            name="databaseName"
            testId="input-databaseName"
            value={formData.databaseName.value}
            onChange={onChangeField}
            helpText={locales.required}
          />
          <TextField
            label={locales.form.sourcePath}
            name="sourcePath"
            testId="input-sourcePath"
            value={formData.sourcePath.value}
            onChange={onChangeField}
            helpText={locales.required}
          />
          <TextField
            label={locales.form.sourceIp}
            name="sourceIp"
            testId="input-sourceIp"
            value={formData.sourceIp.value}
            onChange={onChangeField}
            helpText={locales.required}
          />
          <TextField
            label={locales.form.sourceDomain}
            name="sourceDomain"
            testId="input-sourceDomain"
            value={formData.sourceDomain.value}
            onChange={onChangeField}
            helpText={locales.required}
          />
          <TextField
            label={locales.form.destinationPath}
            name="destinationPath"
            testId="input-destinationPath"
            value={formData.destinationPath.value}
            onChange={onChangeField}
            helpText={locales.optional}
          />
          <TextField
            label={locales.form.sourcePort}
            name="sourcePort"
            testId="input-sourcePort"
            value={formData.sourcePort.value}
            onChange={onChangeField}
            helpText={locales.optional}
          />
        </Styles.Form>
        <Styles.HelpLink>{locales.questions}</Styles.HelpLink>
      </Styles.Wrapper>
    </GenericStep>
  );
};

export default FtpMigrationForm;
